import { render, staticRenderFns } from "./BannerManger.vue?vue&type=template&id=48a452ca"
import script from "./BannerManger.vue?vue&type=script&lang=js"
export * from "./BannerManger.vue?vue&type=script&lang=js"
import style0 from "./BannerManger.vue?vue&type=style&index=0&id=48a452ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports